import React from 'react';
import { organizedItems } from '../data/content';
export function ProblemSection() {
  return <section className="w-full" data-id="element-160" data-mp="2lstiteg186e0">
      <div className="w-full bg-slate-100 px-5 py-12 sm:py-14" data-id="element-161" data-mp="2ltwb9qt06gw1">
        <div className="mx-auto max-w-[760px] text-center" data-id="element-162" data-mp="30hpsffxqlrgq">
          <h2 className="text-balance text-[1.6rem] font-extrabold uppercase leading-[0.95] tracking-tight text-slate-950 sm:text-[2rem]" data-id="element-163" data-mp="30jahwr572k7q">
            Stop Planning Every Health Lesson From Scratch
          </h2>
          <p className="mt-4 text-[1rem] leading-relaxed text-slate-950 sm:text-[1.05rem]" data-id="element-164" data-mp="35gat1ggwid5p">
            Wellness, nutrition, fitness, mental health, relationships, safety…{' '}
            <strong className="font-extrabold" data-id="element-165" data-mp="3jdzccjvblc8n">where do you even start?</strong>
          </p>
          <p className="mt-3 text-[1rem] leading-relaxed text-slate-950 sm:text-[1.05rem]" data-id="element-166" data-mp="3ehs2ifzszglf">
            <strong className="font-extrabold" data-id="element-167" data-mp="1p2auo9xpevkk">HEALTH READY™</strong>{' '}
            gives you a clear, structured path for the whole school year — no
            more building every lesson from zero.
          </p>
          <p className="mt-4 text-[1.1rem] font-extrabold uppercase tracking-tight text-orange-700" data-id="element-168" data-mp="jb0pdgomncbm">
            Choose. Open. Teach.
          </p>
        </div>
      </div>

      <div className="w-full bg-white px-5 py-12 sm:py-14" data-id="element-169" data-mp="sc8kxqzrdz20">
        <div className="mx-auto max-w-[760px] rounded-lg border-l-[6px] border-orange-500 bg-slate-100 p-6 text-left sm:p-8" data-id="element-170" data-mp="x51qgh31xbf5">
          <h3 className="text-[1.1rem] font-extrabold uppercase leading-[0.95] tracking-tight text-slate-950 sm:text-[1.4rem]" data-id="element-171" data-mp="122tgf5k4yngp">
            Stop Searching for Materials in Ten Different Places
          </h3>
          <p className="mt-3 text-[1rem] leading-relaxed text-slate-950 sm:text-[1.05rem]" data-id="element-172" data-mp="1c33rokmm1kt8">
            <strong className="font-extrabold" data-id="element-173" data-mp="1g22xs8k2vnm9">You already know how to teach.</strong>{' '}
            With HEALTH READY™, you choose the topic and everything
            is already organized:
          </p>
          <ul className="mt-4 flex flex-wrap gap-1.5" data-id="element-174" data-mp="3hv98kaou4bp9">
            {organizedItems.map(item => <li key={item} className="rounded-md bg-white px-2.5 py-1 text-[0.9rem] font-semibold text-slate-950" data-id="element-175" data-mp="p0sit7oilwsk">
                {item}.
              </li>)}
          </ul>
          <p className="mt-5 text-[1rem] font-extrabold text-slate-950 sm:text-[1.05rem]" data-id="element-176" data-mp="xym5dqwh9c2j">
            Less preparation. More teaching.
          </p>
        </div>
      </div>
    </section>;
}